module.exports = __webpack_public_path__ + "img/download-grey56.a9d548bf.svg";